import {
    faCheck,
    faCircle,
    faSpinner,
    faTimesCircle,
} from '@fortawesome/free-solid-svg-icons';

export const EVENT_PARTICIPANT_STATUS_OPTIONS = [
    { value: 'open', label: 'event_participants.options.status.open', icon: faCircle },
    { value: 'approved', label: 'event_participants.options.status.approved', icon: faCheck },
    { value: 'failed', label: 'event_participants.options.status.failed', icon: faTimesCircle },
];

export const EVENT_PARTICIPANT_INTERNAL_STATUS_OPTIONS = [
    { value: 'creating', label: 'event_participants.options.status.creating', icon: faSpinner },
    { value: 'queued', label: 'event_participants.options.status.queued', icon: faSpinner },
    { value: 'in_ai_review', label: 'event_participants.options.status.in_ai_review', icon: faSpinner },
];

/** Statuses the user may set manually (open is system-driven via Write). */
export const EVENT_PARTICIPANT_MANUAL_STATUS_VALUES = new Set(['approved', 'failed']);

export const getEventParticipantStatusOptions = (currentStatus, { hasEmail = true } = {}) => {
    const allOptions = [
        ...EVENT_PARTICIPANT_STATUS_OPTIONS,
        ...EVENT_PARTICIPANT_INTERNAL_STATUS_OPTIONS,
    ];

    let options = EVENT_PARTICIPANT_STATUS_OPTIONS.filter((option) => (
        EVENT_PARTICIPANT_MANUAL_STATUS_VALUES.has(option.value)
    ));

    // Approved requires a linked draft/email — no manual skip of Write
    if (!hasEmail) {
        options = options.filter((option) => option.value !== 'approved');
    }

    // Keep current status visible when it is not a manual target (open / creating / queued)
    const current = allOptions.find((option) => option.value === currentStatus);
    if (current && !options.some((option) => option.value === currentStatus)) {
        options = [current, ...options];
    }

    return options;
};
